import { createNamedContext } from '@/utils';
import type { WorkspaceObject } from '@/types';

export const WorkspaceBreadcrumbsContext = createNamedContext<WorkspaceObject[]>(undefined, 'Workspace.Breadcrumbs.Context');